import { NavLink, NavLinkProps } from 'react-router-dom';
import { CSSProperties, ReactNode } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';

export type NavLinkAdapterPropsType = {
	activeClassName?: string;
	activeStyle?: CSSProperties;
	children?: ReactNode;
	to?: string;
	href?: string;
	className?: string;
	style?: CSSProperties;
	role?: string;
	exact?: boolean;
};

/**
 * The NavLinkAdapter component - React Router version
 * Uses React Router NavLink instead of Next.js Link
 */
function NavLinkAdapter(props: NavLinkAdapterPropsType) {
	const {
		children,
		activeClassName = 'active',
		activeStyle,
		role = 'button',
		to,
		href,
		exact,
		..._props
	} = props;

	const location = useLocation();
	const targetUrl = to || href || '/';

	const isActive = exact
		? location.pathname === targetUrl
		: location.pathname.startsWith(targetUrl);

	return (
		<NavLink
			to={targetUrl}
			className={({ isActive: navIsActive }) =>
				clsx(
					_props.className,
					(navIsActive || isActive) ? activeClassName : '',
					location.pathname === targetUrl && 'pointer-events-none'
				)
			}
			style={({ isActive: navIsActive }) =>
				(navIsActive || isActive) ? { ..._props.style, ...activeStyle } : _props.style
			}
			role={role}
			end={exact}
		>
			{children}
		</NavLink>
	);
}

export default NavLinkAdapter;
